<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">
              User Roles
            </h3>
            <h4 class="text-body-1 mb-6">
              Your Reputation depends on your Role, and it is measured by
              points.<br />
              New joiners starts with 0 Reputation points. As you earn
              Reputation points, your Role improves.
            </h4>
          </div>
        </v-col>
        <v-col
          v-for="(role, index) in userRoles"
          :key="index"
          cols="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card outlined>
            <v-card-title class="text-center">
              <span class="d-block text-h6 font-weight-bold w-100-percentage">
                {{ role.name }}
              </span>
            </v-card-title>
            <v-card-text class="text-center">
              <div>
                <span class="font-weight-bold">
                  {{ role.reputationRequired }}
                </span>
                Rep.
              </div>
              <div>
                <span class="font-weight-bold">
                  {{ role.primePhotosRequired }}
                </span>
                Published Photos
              </div>
              <div>
                <span class="text-caption">
                  {{ role.rule }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ReputationRoles',
  data() {
    return {
      curatorDialog: false,
      userRoles: [
        {
          name: 'User',
          reputationRequired: '0',
          primePhotosRequired: '0',
          rule: 'The journey begins',
          icon: ''
        },
        {
          name: 'Scholar',
          reputationRequired: '500',
          primePhotosRequired: '1',
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Student',
          reputationRequired: '1.000',
          primePhotosRequired: '2',
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Photographer',
          reputationRequired: '5.000',
          primePhotosRequired: 5,
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Guru',
          reputationRequired: '10.000',
          primePhotosRequired: '10',
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Master',
          reputationRequired: '20.000',
          primePhotosRequired: '20',
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Grand Master',
          reputationRequired: '50.000',
          primePhotosRequired: '50',
          rule: '(Prime, Inspiration or Elite)',
          icon: ''
        },
        {
          name: 'Artist',
          reputationRequired: '100.000',
          primePhotosRequired: '100',
          rule: '(Prime or Inspiration and min. 20 Elite)',
          icon: ''
        },
        {
          name: 'Legend',
          reputationRequired: '500.000',
          primePhotosRequired: '500',
          rule: '(Prime or Inspiration and min. 50 Elite)',
          icon: ''
        }
      ]
    }
  }
}
</script>
